export const initGenericEmail = () => ({
  type: 'INIT_GENERIC_EMAIL',
});

export const fetchGenericEmailSettingsStats = resp => ({
  type: 'FETCH_GENERIC_EMAIL_SETTINGS_STATS',
  payload: resp
});